import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-76a8aef8")

_pushScopeId("data-v-76a8aef8")
const _hoisted_1 = {
  key: 0,
  class: "ensure-service-explain"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("i", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("保障服务说明 ")
const _hoisted_4 = { class: "demo-tab-width-title" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "demo-tab-width-line" }, null, -1)
const _hoisted_6 = { class: "ensure-standard ensure-section" }
const _hoisted_7 = { class: "ensure-title" }
const _hoisted_8 = { class: "ensure-text" }
const _hoisted_9 = {
  key: 0,
  class: "prop_up_height12"
}
const _hoisted_10 = {
  key: 1,
  class: "prop_up_height20"
}
const _hoisted_11 = {
  key: 1,
  class: "ensure-service-explain explain-chekuang"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("i", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("服务说明 ")
const _hoisted_14 = /*#__PURE__*/_createVNode("h3", { class: "ensure-service-chekuangTit" }, "免责说明", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("p", { class: "ensure-service-chekuangMG" }, [
  /*#__PURE__*/_createTextVNode(" 1.本报告检测内容仅供参考，不可直接作为车辆交易凭证或向腾发索赔的法律依据；"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" 2.如您参考此报告交易车辆，腾发不承担任何检测失误责任，被检车辆后续因车况问题产生的任何交易纠纷由 您自行负责。")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_tab = _resolveComponent("van-tab")
  const _component_van_tabs = _resolveComponent("van-tabs")

  return (_openBlock(), _createBlock("div", null, [
    (!_ctx.state.reportMsg.RpCK())
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", {
            class: "ensure-service-explain-header",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
          }, [
            _hoisted_2,
            _hoisted_3
          ]),
          _createVNode(_component_van_tabs, {
            modelValue: _ctx.state.activeName,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.activeName = $event)),
            scrollspy: "",
            sticky: ""
          }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.contentTextRender[_ctx.state.reportTemplate], (item, index) => {
                return (_openBlock(), _createBlock(_component_van_tab, {
                  key: index,
                  name: item.label
                }, {
                  title: _withId(() => [
                    _createVNode("span", null, [
                      _createVNode("span", _hoisted_4, _toDisplayString(item.label || item.title), 1),
                      _hoisted_5
                    ])
                  ]),
                  default: _withId(() => [
                    _createVNode("div", _hoisted_6, [
                      _createVNode("div", _hoisted_7, _toDisplayString(item.title), 1),
                      _createVNode("div", _hoisted_8, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.content, (itemp) => {
                          return (_openBlock(), _createBlock("p", { key: itemp }, [
                            (itemp === 'prop_up_height12')
                              ? (_openBlock(), _createBlock("span", _hoisted_9))
                              : (itemp === 'prop_up_height20')
                                ? (_openBlock(), _createBlock("span", _hoisted_10))
                                : (_openBlock(), _createBlock("span", {
                                    key: 2,
                                    innerHTML: itemp,
                                    class: {'bold': item.weight === 'bold'}
                                  }, null, 10, ["innerHTML"]))
                          ]))
                        }), 128))
                      ])
                    ])
                  ]),
                  _: 2
                }, 1032, ["name"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.state.reportMsg.RpCK())
      ? (_openBlock(), _createBlock("div", _hoisted_11, [
          _createVNode("div", {
            class: "ensure-service-explain-header",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
          }, [
            _hoisted_12,
            _hoisted_13
          ]),
          _hoisted_14,
          _hoisted_15
        ]))
      : _createCommentVNode("", true)
  ]))
})